import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../data/translations';

export const useTranslation = () => {
    const { currentLanguage } = useLanguage();

    const t = (key, params = {}) => {
        let translation = translations[currentLanguage]?.[key] || translations.en[key] || key;

        // Handle parameter interpolation
        if (params && typeof translation === 'string') {
            Object.keys(params).forEach(paramKey => {
                const regex = new RegExp(`{{${paramKey}}}`, 'g');
                translation = translation.replace(regex, params[paramKey]);
            });
        }

        return translation;
    };

    return { t, currentLanguage };
};